import React, { createContext, ReactNode, useEffect, useState } from "react";
// import * as Sentry from "@sentry/react";

export const ErrorAlertContext = createContext({
  showAlert: false,
  alertMessage: "",
  onShowAlert: (error: any, message: string) => {},
});

const ErrorAlertContextProvider = ({ children }: { children: ReactNode }) => {
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  useEffect(() => {
    if (showAlert) {
      const timer = setTimeout(() => {
        setShowAlert(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showAlert]);

  const onShowAlert = (err: any, message: string) => {
    setShowAlert(true);
    setAlertMessage(message);
    // Sentry.captureException(err);
  };

  return (
    <ErrorAlertContext.Provider
      value={{
        showAlert,
        alertMessage,
        onShowAlert,
      }}
    >
      {children}
    </ErrorAlertContext.Provider>
  );
};

export default ErrorAlertContextProvider;
